import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'
import { useGetActiveLeadSource } from './getActiveLeadSource'
import { useNavigate } from 'react-router-dom'

export const useGetActiveLeadSourceDetails = (title: string) => {
   const { mutate: isLoadingActiveLeadSource } = useGetActiveLeadSource(
      title as string
   )
   const navigate = useNavigate()
   const {
      data: initialData,
      error,
      isValidating,
      mutate,
   } = useSWR(
      title ? [QUERY_KEYS.GET_LEAD_SOURCE_DETAILS, title] : null,
      async () => {
         try {
            const data = await CampaignService.getActiveLeadSources(title)
            if (data && data.draft !== null) {
               const draftData =
                  await CampaignService.getActiveLeadSourcesFromDraft(title)

               isLoadingActiveLeadSource()
               return draftData
            }

            return data
         } catch (error) {
            navigate('/campaign')
            throw error
         }
      }
   )

   return {
      data: initialData,
      isLoading: isValidating,
      error,
      mutate,
   }
}
